import { render, staticRenderFns } from "./MenuSelection.vue?vue&type=template&id=72ea6142&scoped=true&"
import script from "./MenuSelection.vue?vue&type=script&lang=js&"
export * from "./MenuSelection.vue?vue&type=script&lang=js&"
import style0 from "./MenuSelection.vue?vue&type=style&index=0&id=72ea6142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea6142",
  null
  
)

export default component.exports